import i18next from 'i18next';
import * as Yup from 'yup';

export const schema = Yup.object().shape({
  email: Yup.string().email(i18next.t('validation.notValid')).required(i18next.t('validation.required.email')),
});
